/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

class InputGroup extends React.Component {
  handleChange = selectedOption => {
    this.props.onChange({
      value: selectedOption,
      field: this.props.field.fieldName,
    });
  };

  render() {
    const { value, field } = this.props;
    const { options, defaultValue, className } = field;
    const valueOption = typeof value === "string" ? options.find(it => it?.value === value) : value;
    const defaultOption = defaultValue ? options.find(it => defaultValue.includes(it.value)) : null;

    const newOptions = options.map(option => {
      if (option?.value && option?.value) {
        return option;
      }
      return { value: option, label: option };
    });

    return (
      <fieldset className={className}>
        <Select
          value={valueOption || defaultOption || null}
          onChange={this.handleChange}
          options={newOptions}
        />
      </fieldset>
    );
  }
}

InputGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default InputGroup;
